export default __webpack_public_path__ + "img/5621d58c53c51c8dec054c1bbb6757fb.svg";